module.exports = {
    css: {
        loaderOptions: {
            sass: {
                additionalData: '@import "~@/styles/utils/_vars.scss";'
            }
        }
    },

    chainWebpack: (config) => {
        const svgRule = config.module.rule('svg')

        svgRule.uses.clear()

        svgRule
            .use('babel-loader')
            .loader('babel-loader')
            .end()
            .use('vue-svg-loader')
            .loader('vue-svg-loader')
    },

    pluginOptions: {
        prerenderSpa: {
            registry: undefined,
            renderRoutes: ['/'],
            useRenderEvent: false,
            headless: true,
            onlyProduction: true
        }
    },

    publicPath:
        process.env.NODE_ENV === 'production' ? '/jetflix-vacations/' : '/',

    outputDir: 'dist/jetflix-vacations/'
}
